import { render, staticRenderFns } from "./searchPlus.vue?vue&type=template&id=8b3491f6&scoped=true"
import script from "./searchPlus.vue?vue&type=script&lang=js"
export * from "./searchPlus.vue?vue&type=script&lang=js"
import style0 from "./searchPlus.vue?vue&type=style&index=0&id=8b3491f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3491f6",
  null
  
)

export default component.exports